import { render } from "./Index.vue?vue&type=template&id=80a687e4"
const script = {}

import exportComponent from "/codebuild/output/src3818363008/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__